/* eslint-disable no-sequences */

import React from "react";
import Components from "mpm-components";
import { FormattedMessage } from "react-intl";
import { Form, Button, TextArea, Divider, Checkbox } from "semantic-ui-react";
import mpmServices from "mpm-services";
import { toClass } from "class-converter";
import { SourceEXView } from "mpm-classes/CessionExport";
import Utilities from "mpm-config/Utilities";
import NumberFormat from "react-number-format";

export default ({ cessionExport, entities }) => {
    const [selectedSource, setSelectedSource] = React.useState(null);
  
    const onSelectSource = (source) => {
      setSelectedSource({loading: true});
      mpmServices.CessionsExportDataService.loadSourceView(source.id).then(result => {
        const sourceEXP = result.data;
        sourceEXP.typeSource = source.typeSource;
        sourceEXP.codeSource = source.codeSource;
        setSelectedSource(toClass(sourceEXP, SourceEXView))
      }).catch(error => {
        setSelectedSource({loading: false});
      })
    };
  
    return (
      <>
        <Components.Regions.RegionWithHeader
          title="label.type-source"
          headerColor="blue"
          headerSize="small"
         
        >
          <Components.Tables.SmartTable
            header={[
              
              {
                selector: "cc",
                textAlign: "center",
                label: (
                  <FormattedMessage tagName="label" id="menu.cession.capture" />
                ),
              },
              {
                selector: "cp",
                textAlign: "center",
                label: (
                  <FormattedMessage tagName="label" id="menu.cession.product" />
                ),
              },
              {
                collapsing: true,
                textAlign: "center",
                label: (
                  <FormattedMessage tagName="label" id="label.table.actions" />
                ),
                component: (source) => (
                  <Button size="mini" onClick={() => onSelectSource(source)}>
                    Détails Espèses
                  </Button>
                ),
              },
            ]}
            data={cessionExport.childrenSourceEXP}
            grouped={false}
            pagination={true}
            striped={true}
            sortable={true}
            rowsPerPage={5}
          />
        </Components.Regions.RegionWithHeader>
  
        {selectedSource && (
          <Components.Regions.RegionWithHeader
            title="label.especes"
            headerColor="blue"
            headerSize="small"
            loading={selectedSource.loading}
            className="scrolling-x"
          >
            <Form>
              <Form.Group widths="equal">
                <Form.Dropdown
                options={Utilities.getCPTypeSourceDropDownOptions()}
                  label="Type Source"
                  disabled
                  selection
                  search
                  value={selectedSource.typeSource}
                />
                <Form.Input
                  label="Code Source"
                  disabled
                  value={selectedSource.codeSource}
                />
              </Form.Group>
            </Form>
            {selectedSource.childrenSrcEsp && (<>
              <Components.Tables.SmartTable
                header={[
                  {
                    selector: "sourceDetail",
                    textAlign: "center",
                    collapsing: true,
                    component: (row) => <TextArea value={row.sourceDetail} />,
                    label: <FormattedMessage tagName="label" id="label.source" />,
                  },
                  {
                    selector: "navire",
                    textAlign: "center",
                    label: "Navire",
                  },
                  {
                    selector: "refEspece.libelle",
                    textAlign: "center",
                    label: <FormattedMessage tagName="label" id="label.espece" />,
                  },
                  {
                    selector: "refTypeTransf.nom",
                    textAlign: "center",
                    label: "Type transformation"
                  },
         
                  {
                    selector: "poidCD",
                    textAlign: "center",
                    label: "Poids CD (KG)",
                    component: (row) => <NumberFormat min={0}  displayType={"text"} 
                          thousandSeparator=" " decimalScale={3} 
                          allowedDecimalSeparators={'.', ','} value={row.poidCD} />
                  },
                  {
                    selector: "poidExporte",
                    textAlign: "center",
                    label: "Poids exporté (KG)",
                    component: (row) => <NumberFormat min={0}  displayType={"text"} 
                          thousandSeparator=" " decimalScale={3} 
                          allowedDecimalSeparators={'.', ','} value={row.poidExporte} />
                  },
                  {
                    selector: "codeSH",
                    textAlign: "center",
                    label: "Code SH",
                  },
                  {
                    selector: "autreTypeTransf",
                    textAlign: "center",
                    label: <FormattedMessage tagName="label" id="label.autre-transformation" />,
                  },
             
                  {
                    selector: "observations",
                    textAlign: "center",
                    label: "Observations",
                  },
                  {
                    selector: "imprime",
                    textAlign: "center",
                    label: "Imprimé",
                    component : (row) => <Checkbox toggle disabled value={row.imprime} />
                  },
                  {
                    selector: "rendementG",
                    textAlign: "center",
                    label: "Rendement G",
                    component: (row) => <NumberFormat min={0}  displayType={"text"} 
                          thousandSeparator=" " decimalScale={3} 
                          allowedDecimalSeparators={'.', ','} value={row.rendementG} />
                  },
                ]}
                data={selectedSource.childrenSrcEsp}
                grouped={false}
                pagination={true}
                striped={true}
                sortable={true}
                rowsPerPage={5}
                selectable={false}
              />
              <Divider />
              <Components.Tables.SmartTable
                header={[
                  
                  {
                    selector: "refEspece.libelle",
                    textAlign: "center",
                    label: <FormattedMessage tagName="label" id="label.espece" />,
                  },
           
                  {
                    selector: "poidCD",
                    textAlign: "center",
                    label: "Poids CD (KG)",
                    component: (row) => <NumberFormat min={0}  displayType={"text"} 
                          thousandSeparator=" " decimalScale={3} 
                          allowedDecimalSeparators={'.', ','} value={row.poidCD} />
                  },
                  {
                    selector: "poidExporte",
                    textAlign: "center",
                    label: "Poids exporté (KG)",
                    component: (row) => <NumberFormat min={0}  displayType={"text"} 
                          thousandSeparator=" " decimalScale={3} 
                          allowedDecimalSeparators={'.', ','} value={row.poidExporte} />
                  },
                  
             
                ]}
                data={selectedSource.childrenSrcEsp}
                grouped={true}
                hideGroupIcon
                groupeBy="refEspece.libelle"
                groupeSums={[ "poidCD", "poidExporte"]}
                pagination={true}
                striped={true}
                sortable={true}
                rowsPerPage={5}
                selectable={false}
              />
              </>
            )}
          </Components.Regions.RegionWithHeader>
        )}
      </>
    );
  };
  